import Swal from 'sweetalert2';

const commonConfig = {
  backdrop: `rgba(0,0,0,0.4)`,
  allowOutsideClick: false,
  position: 'center',
  width: 400,
  heightAuto: true,
  showClass: {
    popup: 'swal2-show',
  },
  customClass: {
    container: 'swal2-container-high-z-index',
  },
};

export const showSuccessAlert = (message, timer = 1500) => {
  return Swal.fire({
    icon: 'success',
    text: message,
    timer,
    showConfirmButton: false,
    ...commonConfig,
  });
};

export const showErrorAlert = (message) => {
  return Swal.fire({
    icon: 'error',
    text: message,
    ...commonConfig,
  });
};

export const showWarningAlert = (message) => {
  return Swal.fire({
    icon: 'warning',
    text: message,
    ...commonConfig,
  });
};

export const showConfirmationAlert = (message) => {
  return Swal.fire({
    icon: 'question',
    text: message,
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    ...commonConfig,
  });
};
